import { styled, Tooltip, tooltipClasses, type TooltipProps } from '@mui/material';

const ErrorTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#d32f2f',
    color: '#fff',
    fontSize: '0.75rem',
    fontWeight: 500,
    padding: '6px 12px',
    borderRadius: 6,
    maxWidth: 280,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#d32f2f',
  },
});

type ValidationErrorTooltipProps = {
  error: string;
  children: React.ReactElement;
};

export const ValidationErrorTooltip = ({ error, children }: ValidationErrorTooltipProps) => (
  <ErrorTooltip title={error} arrow placement="bottom">
    {children}
  </ErrorTooltip>
);
